import NanoBanner from './NanoBanner';

export default NanoBanner;
